
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/sadhguru/[mmm]",
      function () {
        return require("private-next-pages/[region]/sadhguru/[mmm]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/sadhguru/[mmm]"])
      });
    }
  